import Vue from "vue";
Vue.directive('html-md', (el, binding, vnode) => {
    let content = binding.value
    if(content === undefined || content === null){
        content = ''
    }
    const markdownRenderer = vnode.context.$markDown
    //el.innerHTML = markdownRenderer.render(content) || content
    const newHTML = markdownRenderer.render(content) || content;
    // 仅当内容真正变化时更新DOM
     if (el.__cached_html !== newHTML) {
        // 创建临时容器比较DOM变化
        const temp = document.createElement('div');
        temp.innerHTML = newHTML;
        el.innerHTML = temp.innerHTML;
        el.__cached_html = newHTML; // 缓存当前内容
    }
})